import React from "react";
import {
  ArrowRight,
  ArrowLeft,
  Dashboard,
  CheckmarkOutline,
  Analytics,
  Sdk,
  WorkflowAutomation,
} from "@carbon/icons-react";
import Syns from "../assets/syns.svg";

const TagaPlatformOverview: React.FC = () => {
  return (
    <section className="py-16 sm:py-20  bg-gradient-to-br from-blue-50 via-white to-indigo-50 flex flex-col items-center">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-center mb-12 sm:mb-16 text-gray-900 max-w-4xl mx-auto">
          Quản lý và mở rộng hoạt động của bạn với một, một số, hoặc tất cả các
          thành phần của Ứng dụng Taga
        </h1>

        <div className="flex flex-col lg:flex-row items-start gap-6 lg:gap-4 min-h-[500px] w-full">
          {/* Left Side Container */}
          <div className="flex md:flex-col gap-1 w-full lg:w-auto">
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <button className="w-full sm:w-[200px] h-36 sm:h-44 rounded-xl p-2 flex flex-col justify-center items-center border-none bg-white shadow-lg">
                <p className="text-gray-900 text-center text-sm font-semibold mb-3 sm:mb-4">
                  Tổ chức / dữ liệu của bạn
                </p>
                <div className="grid grid-cols-4 gap-1 sm:gap-2">
                  <div className="w-4 h-4 sm:w-6 sm:h-6 bg-blue-500 rounded"></div>
                  <div className="w-4 h-4 sm:w-6 sm:h-6 bg-red-500 rounded"></div>
                  <div className="w-4 h-4 sm:w-6 sm:h-6 bg-green-500 rounded"></div>
                  <div className="w-4 h-4 sm:w-6 sm:h-6 bg-purple-500 rounded"></div>
                  <div className="w-4 h-4 sm:w-6 sm:h-6 bg-yellow-500 rounded"></div>
                  <div className="w-4 h-4 sm:w-6 sm:h-6 bg-indigo-500 rounded"></div>
                  <div className="w-4 h-4 sm:w-6 sm:h-6 bg-pink-500 rounded"></div>
                  <div className="w-4 h-4 sm:w-6 sm:h-6 bg-cyan-500 rounded"></div>
                </div>
              </button>
              <div className="flex sm:flex-col w-full sm:w-[100px]">
                <div className="flex flex-row sm:flex-col items-center justify-center w-full">
                  <ArrowLeft
                    size={24}
                    className="text-gray-400 hidden sm:block"
                  />
                  <div className="mb-2 px-2 sm:px-0">
                    <p className="font-semibold mb-0 text-xs sm:text-sm text-gray-700 text-center sm:text-left">
                      Truy vấn dữ liệu ở vị trí hiện tại
                    </p>
                  </div>
                  <ArrowRight
                    size={24}
                    className="text-gray-400 hidden sm:block"
                  />
                </div>
              </div>
            </div>

            <div className="flex items-center pl-12 gap-5">
              <img
                src={Syns}
                alt="Syns"
                className="w-16 h-16 sm:w-auto sm:h-auto"
              />
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-4">
              <button className="w-full sm:w-[200px] h-36 sm:h-44 rounded-xl p-4 flex flex-col justify-center items-center border-none bg-white shadow-lg">
                <p className="text-gray-900 text-center text-sm font-semibold mb-2">
                  Thiết bị làm việc của bạn
                </p>
                <p className="text-xs text-gray-600 text-center font-medium">
                  Ứng dụng và hệ thống
                </p>
              </button>
              <div className="flex sm:flex-col w-full sm:w-[100px]">
                <div className="flex flex-row sm:flex-col items-center justify-center w-full">
                  <ArrowLeft
                    size={24}
                    className="text-gray-400 hidden sm:block"
                  />
                  <div className="mb-2 px-2 sm:px-0">
                    <p className="font-semibold mb-0 text-xs sm:text-sm text-gray-700 text-center sm:text-left">
                      Gửi dữ liệu đến backends
                    </p>
                    <p className="font-bold text-xs text-gray-500 mb-0 text-center sm:text-left">
                      API, Taga Protocol
                    </p>
                  </div>
                  <ArrowRight
                    size={24}
                    className="text-gray-400 hidden sm:block"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Main Diagram Container */}
          <div className="flex items-end gap-4 w-full">
            <div className="bg-white/80 rounded-xl p-3 sm:p-4 w-full">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                {/* Visualization */}
                <button className="col-span-1 sm:col-span-2 lg:col-span-3 bg-gradient-to-r from-slate-100 to-slate-200 rounded-lg p-3 border-none relative overflow-hidden">
                  <div className="relative z-10">
                    <div className="flex items-center justify-center sm:justify-start mb-2">
                      <Dashboard
                        size={20}
                        className="mr-2 text-gray-700 sm:w-6 sm:h-6"
                      />
                      <span className="text-gray-900 font-semibold text-sm sm:text-base">
                        Quản lý & Trực quan hóa
                      </span>
                    </div>
                  </div>
                </button>

                {/* Testing */}
                <div className="bg-purple-500 rounded-lg p-3 text-white">
                  <div className="flex items-center mb-2">
                    <CheckmarkOutline
                      size={20}
                      className="mr-2 sm:w-6 sm:h-6"
                    />
                    <span className="font-semibold text-sm sm:text-base">
                      Kiểm thử
                    </span>
                  </div>
                  <div className="space-y-2">
                    <button className="block w-full text-left text-xs sm:text-sm font-medium bg-white/20 rounded px-2 sm:px-3 py-1">
                      Dữ liệu luôn sẵn sàng
                    </button>
                    <button className="block w-full text-left text-xs sm:text-sm font-medium bg-white/20 rounded px-2 sm:px-3 py-1">
                      Giám sát tổng hợp
                    </button>
                  </div>
                </div>

                {/* Observability Solutions */}
                <div className="bg-blue-500 rounded-lg p-3 text-white">
                  <div className="flex items-center mb-2">
                    <Analytics
                      size={20}
                      className="mr-2 sm:w-6 sm:h-6"
                    />
                    <span className="font-semibold text-sm sm:text-base">
                      Giải pháp quản lý
                    </span>
                  </div>
                  <div className="space-y-2">
                    <button className="block w-full text-left text-xs sm:text-sm font-medium bg-white/20 rounded px-2 sm:px-3 py-1">
                      Frontend
                    </button>
                    <button className="block w-full text-left text-xs sm:text-sm font-medium bg-white/20 rounded px-2 sm:px-3 py-1">
                      Ứng dụng
                    </button>
                    <button className="block w-full text-left text-xs sm:text-sm font-medium bg-white/20 rounded px-2 sm:px-3 py-1">
                      Hạ tầng
                    </button>
                  </div>
                </div>

                {/* Incident Response */}
                <div className="bg-green-500 rounded-lg p-3 text-white sm:col-span-2 lg:col-span-1">
                  <div className="flex items-center mb-2">
                    <Analytics
                      size={20}
                      className="mr-2 sm:w-6 sm:h-6"
                    />
                    <span className="font-semibold text-sm sm:text-base">
                      Quản lý tiến độ
                    </span>
                  </div>
                  <div className="space-y-2">
                    <button className="block w-full text-left text-xs sm:text-sm font-medium bg-white/20 rounded px-2 sm:px-3 py-1">
                      Trực quan hóa tiến độ
                    </button>
                    <button className="block w-full text-left text-xs sm:text-sm font-medium bg-white/20 rounded px-2 sm:px-3 py-1">
                      Giám sát năng suất
                    </button>
                  </div>
                </div>

                {/* Key Capabilities */}
                <div className="col-span-1 sm:col-span-2 lg:col-span-3 bg-orange-500 rounded-lg p-3 text-white">
                  <div className="flex items-center mb-3 sm:mb-4">
                    <Sdk
                      size={20}
                      className="mr-2 sm:w-6 sm:h-6"
                    />
                    <span className="font-semibold text-base sm:text-lg">
                      Xử lý hạ tầng
                    </span>
                  </div>
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                    <button className="text-xs sm:text-sm font-medium bg-white/20 rounded px-2 sm:px-3 py-2">
                      Workflow Processor
                    </button>
                    <button className="text-xs sm:text-sm font-medium bg-white/20 rounded px-2 sm:px-3 py-2">
                      Permission Delegator
                    </button>
                    <button className="text-xs sm:text-sm font-medium bg-white/20 rounded px-2 sm:px-3 py-2">
                      Workflow Step Rule
                    </button>
                    <button className="text-xs sm:text-sm font-medium bg-white/20 rounded px-2 sm:px-3 py-2">
                      Tracklog Processor
                    </button>
                    <button className="text-xs sm:text-sm font-medium bg-white/20 rounded px-2 sm:px-3 py-2">
                      Data Element Handler
                    </button>
                    <button className="text-xs sm:text-sm font-medium bg-white/20 rounded px-2 sm:px-3 py-2">
                      Taga D2d Protocol
                    </button>
                  </div>
                </div>

                {/* Building Blocks */}
                <div className="col-span-1 sm:col-span-2 lg:col-span-3 bg-yellow-500 rounded-lg p-3 text-white">
                  <div className="flex items-center mb-3 sm:mb-4">
                    <WorkflowAutomation
                      size={20}
                      className="mr-2 sm:w-6 sm:h-6"
                    />
                    <span className="font-semibold text-base sm:text-lg">
                      Khối xây dựng: cơ sở dữ liệu quy trình (TAGA+)
                    </span>
                  </div>
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                    <button className="text-xs sm:text-sm font-medium bg-white/20 rounded px-2 sm:px-3 py-2 flex flex-col items-center">
                      <p className="text-xs sm:text-sm text-white font-semibold mb-0">
                        Dataform
                      </p>
                      <span className="text-xs">Dữ liệu</span>
                    </button>
                    <button className="text-xs sm:text-sm font-medium bg-white/20 rounded px-2 sm:px-3 py-2 flex flex-col items-center">
                      <p className="text-xs sm:text-sm text-white font-semibold mb-0">
                        Tasks
                      </p>
                      <span className="text-xs">Công việc</span>
                    </button>
                    <button className="text-xs sm:text-sm font-medium bg-white/20 rounded px-2 sm:px-3 py-2 flex flex-col items-center">
                      <p className="text-xs sm:text-sm text-white font-semibold mb-0">
                        Diagram
                      </p>
                      <span className="text-xs">Quy trình</span>
                    </button>
                    <button className="text-xs sm:text-sm font-medium bg-white/20 rounded px-2 sm:px-3 py-2 flex flex-col items-center">
                      <p className="text-xs sm:text-sm text-white font-semibold mb-0">
                        Reports
                      </p>
                      <span className="text-xs">Báo cáo</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TagaPlatformOverview;
